import './VideosComponent.css';

const VideosComponent = () => {

    return <div className="viewport grid-parent videos-layout">
        <video
            id="video-1"
            className="video-panel"
            autoPlay
            loop
            muted
            playsInline
        >
            <source src="https://pixay-website-assets.s3.us-east-1.amazonaws.com/videos/traffic_video_1.mov" />
        </video>
        <video
            id="video-2"
            className="video-panel"
            autoPlay
            loop
            muted
            playsInline 
            width="250"
        >
            <source src="https://pixay-website-assets.s3.us-east-1.amazonaws.com/videos/traffic_video_2.MOV" />
        </video>
        <video
            id="video-3"
            className="video-panel"
            autoPlay
            loop
            muted
            playsInline 
            width="250"
        >
            <source src="https://pixay-website-assets.s3.us-east-1.amazonaws.com/videos/traffic_video_3.mov" />
        </video>
    </div>
};

export default VideosComponent;